export const tvList = [
  {
    id: "t1",
    type: "tv",
    title: "长安十二时辰录",
    cover: "https://readdy.ai/api/search-image?query=Historical%20chinese%20drama%20poster%20of%20ancient%20tang%20dynasty%20city%20at%20dusk%20with%20lanterns%20and%20palace%20roofs%2C%20rich%20red%20and%20gold%20tones%2C%20epic%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-01&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "悬疑", "剧情"],
    rating: 8.8,
    director: "曹振",
    actors: ["雷宇", "易烊千城", "周一围"],
    summary: "上元佳节前夕，长安城暗流涌动。一名死囚与一位少年联手，在十二个时辰内阻止一场足以颠覆王朝的阴谋。",
    duration: 45,
    status: "全24集",
    episodes: [
      { id: "t1e1", number: 1, title: "上元之夜", duration: 46 },
      { id: "t1e2", number: 2, title: "暗桩", duration: 44 },
      { id: "t1e3", number: 3, title: "烽火台", duration: 45 },
      { id: "t1e4", number: 4, title: "旧人重逢", duration: 45 },
      { id: "t1e5", number: 5, title: "狼卫来袭", duration: 47 },
      { id: "t1e6", number: 6, title: "长安危局", duration: 46 },
      { id: "t1e7", number: 7, title: "真相初现", duration: 45 },
      { id: "t1e8", number: 8, title: "最后一搏", duration: 48 },
    ],
    tags: ["古装", "悬疑", "高口碑"],
  },
  {
    id: "t2",
    type: "tv",
    title: "都市夜归人",
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20young%20professionals%20walking%20in%20rainy%20city%20at%20night%20with%20office%20towers%2C%20cool%20blue%20and%20warm%20streetlight%20tones%2C%20urban%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-02&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "爱情", "剧情"],
    rating: 7.9,
    director: "林晓晴",
    actors: ["杨紫萱", "李现城", "白鹿"],
    summary: "三个在大城市打拼的年轻人，在深夜的便利店相遇。他们各自背负着生活的重量，却在彼此身上找到了继续前行的勇气。",
    duration: 42,
    status: "更新至第18集",
    episodes: [
      { id: "t2e1", number: 1, title: "深夜便利店", duration: 42 },
      { id: "t2e2", number: 2, title: "第一次心动", duration: 41 },
      { id: "t2e3", number: 3, title: "加班到天明", duration: 43 },
      { id: "t2e4", number: 4, title: "租房风波", duration: 42 },
      { id: "t2e5", number: 5, title: "告白与告别", duration: 42 },
      { id: "t2e6", number: 6, title: "各自的选择", duration: 44 },
    ],
    tags: ["都市", "爱情", "职场"],
  },
  {
    id: "t3",
    type: "tv",
    title: "迷雾档案",
    cover: "https://readdy.ai/api/search-image?query=Crime%20investigation%20tv%20series%20poster%20of%20a%20detective%20board%20with%20photos%20and%20red%20strings%20in%20dim%20office%2C%20dark%20teal%20and%20amber%20tones%2C%20mysterious%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-03&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.5,
    director: "郑铭",
    actors: ["秦岚", "王砚辉", "谭卓"],
    summary: "法医与刑警组成搭档，从一具无名尸开始，层层揭开尘封多年的系列案件。每一份档案背后，都是一个不愿被遗忘的灵魂。",
    duration: 44,
    status: "全30集",
    episodes: [
      { id: "t3e1", number: 1, title: "无名之尸", duration: 44 },
      { id: "t3e2", number: 2, title: "失踪者", duration: 43 },
      { id: "t3e3", number: 3, title: "旧案重现", duration: 44 },
      { id: "t3e4", number: 4, title: "证词", duration: 45 },
      { id: "t3e5", number: 5, title: "真相边缘", duration: 44 },
    ],
    tags: ["悬疑", "刑侦", "烧脑"],
  },
  {
    id: "t4",
    type: "tv",
    title: "权力之巅",
    cover: "https://readdy.ai/api/search-image?query=Political%20thriller%20tv%20poster%20of%20a%20silhouette%20figure%20standing%20before%20imposing%20capitol%20columns%2C%20cold%20steel%20blue%20and%20gold%20tones%2C%20tense%20power%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-04&orientation=portrait",
    year: 2023,
    region: "美国",
    genres: ["剧情", "政治", "惊悚"],
    rating: 8.9,
    director: "Rachel Ford",
    actors: ["David Kane", "Helen Marsh", "Peter Yule"],
    summary: "在一场势均力敌的选举背后，权力的游戏远比想象中残酷。理想主义者踏入政坛的那一刻，就已经站在了悬崖边缘。",
    duration: 52,
    status: "全22集",
    episodes: [
      { id: "t4e1", number: 1, title: "竞选开始", duration: 52 },
      { id: "t4e2", number: 2, title: "暗箱", duration: 50 },
      { id: "t4e3", number: 3, title: "背叛", duration: 53 },
      { id: "t4e4", number: 4, title: "最后一票", duration: 55 },
    ],
    tags: ["政治", "美剧", "高分"],
  },
  {
    id: "t5",
    type: "tv",
    title: "山居食记",
    cover: "https://readdy.ai/api/search-image?query=Warm%20healing%20tv%20drama%20poster%20of%20a%20rustic%20wooden%20table%20with%20steaming%20homemade%20dishes%20and%20greenery%2C%20cozy%20green%20and%20amber%20tones%2C%20peaceful%20countryside%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-05&orientation=portrait",
    year: 2025,
    region: "日本",
    genres: ["治愈", "美食", "剧情"],
    rating: 8.6,
    director: "小林聪美",
    actors: ["松重丰", "高畑充希", "桥爪功"],
    summary: "一位厌倦都市的料理人回到深山开了一间小食堂，用最朴素的食材治愈每一位到访的客人，也治愈了自己。",
    duration: 30,
    status: "更新至第10集",
    episodes: [
      { id: "t5e1", number: 1, title: "开张", duration: 30 },
      { id: "t5e2", number: 2, title: "雨季", duration: 30 },
      { id: "t5e3", number: 3, title: "秋收", duration: 29 },
      { id: "t5e4", number: 4, title: "冬雪", duration: 31 },
      { id: "t5e5", number: 5, title: "春来", duration: 30 },
    ],
    tags: ["治愈", "美食", "日剧"],
  },
  {
    id: "t6",
    type: "tv",
    title: "仙途问道",
    cover: "https://readdy.ai/api/search-image?query=Xianxia%20fantasy%20chinese%20drama%20poster%20of%20a%20cultivator%20standing%20on%20floating%20mountains%20with%20mist%20and%20swords%2C%20jade%20green%20and%20gold%20tones%2C%20ethereal%20epic%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-06&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "仙侠", "奇幻"],
    rating: 7.8,
    director: "尹涛",
    actors: ["肖战宇", "迪丽热娜", "陈飞宇"],
    summary: "一个平凡的宗门杂役意外得到上古传承，从此踏上仙途。大道三千，他偏要走出属于自己的那一条。",
    duration: 45,
    status: "全40集",
    episodes: [
      { id: "t6e1", number: 1, title: "杂役少年", duration: 45 },
      { id: "t6e2", number: 2, title: "上古传承", duration: 44 },
      { id: "t6e3", number: 3, title: "御剑出宗", duration: 46 },
      { id: "t6e4", number: 4, title: "宗门大比", duration: 45 },
      { id: "t6e5", number: 5, title: "魔道来袭", duration: 47 },
      { id: "t6e6", number: 6, title: "问心之道", duration: 45 },
    ],
    tags: ["仙侠", "古装", "玄幻"],
  },
  {
    id: "t7",
    type: "tv",
    title: "急诊风云",
    cover: "https://readdy.ai/api/search-image?query=Medical%20drama%20tv%20poster%20of%20doctors%20in%20scrubs%20rushing%20in%20bright%20emergency%20room%2C%20clean%20white%20and%20teal%20clinical%20tones%2C%20intense%20urgent%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-07&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["医疗", "剧情", "职业"],
    rating: 8.2,
    director: "张黎",
    actors: ["靳东明", "海清", "雷佳音"],
    summary: "急诊科的走廊永远灯火通明，每一次抢救都是与死神的赛跑。医生们在拯救生命的同时，也在面对自己的困境与抉择。",
    duration: 44,
    status: "全36集",
    episodes: [
      { id: "t7e1", number: 1, title: "生死一线", duration: 44 },
      { id: "t7e2", number: 2, title: "深夜抢救", duration: 43 },
      { id: "t7e3", number: 3, title: "医者仁心", duration: 44 },
      { id: "t7e4", number: 4, title: "难以抉择", duration: 45 },
    ],
    tags: ["医疗", "职业", "现实"],
  },
  {
    id: "t8",
    type: "tv",
    title: "英伦谜案",
    cover: "https://readdy.ai/api/search-image?query=British%20mystery%20tv%20poster%20of%20a%20foggy%20london%20street%20with%20gas%20lamps%20and%20a%20trench%20coat%20detective%2C%20muted%20green%20and%20grey%20tones%2C%20victorian%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-08&orientation=portrait",
    year: 2022,
    region: "欧洲",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.7,
    director: "Arthur Penrose",
    actors: ["Hugh Grantley", "Emma Collins", "Sean Wells"],
    summary: "维多利亚时代的伦敦，一位落魄贵族与一名警探联手侦破离奇命案。雾都之下，真相往往比想象中更加黑暗。",
    duration: 50,
    status: "全16集",
    episodes: [
      { id: "t8e1", number: 1, title: "雾夜", duration: 50 },
      { id: "t8e2", number: 2, title: "密码", duration: 49 },
      { id: "t8e3", number: 3, title: "庄园疑云", duration: 51 },
    ],
    tags: ["悬疑", "英剧", "古典"],
  },
  {
    id: "t9",
    type: "tv",
    title: "青春练习题",
    cover: "https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20poster%20of%20students%20in%20uniforms%20running%20under%20sunlit%20campus%20trees%2C%20bright%20fresh%20green%20and%20sky%20blue%20tones%2C%20energetic%20innocent%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-09&orientation=portrait",
    year: 2025,
    region: "韩国",
    genres: ["校园", "爱情", "青春"],
    rating: 7.9,
    director: "朴信厚",
    actors: ["金秀贤成", "李知恩", "车银优"],
    summary: "高三那年，转学生与原班长成了同桌。在堆积如山的试卷里，他们一边为梦想冲刺，一边悄悄写下了关于青春的心事。",
    duration: 38,
    status: "更新至第14集",
    episodes: [
      { id: "t9e1", number: 1, title: "转学生", duration: 38 },
      { id: "t9e2", number: 2, title: "同桌", duration: 37 },
      { id: "t9e3", number: 3, title: "运动会", duration: 39 },
      { id: "t9e4", number: 4, title: "毕业季", duration: 38 },
    ],
    tags: ["青春", "校园", "甜宠"],
  },
  {
    id: "t10",
    type: "tv",
    title: "谍影迷城",
    cover: "https://readdy.ai/api/search-image?query=Spy%20thriller%20tv%20poster%20of%20a%20secret%20agent%20in%20long%20coat%20on%20crowded%20european%20square%20with%20old%20buildings%2C%20desaturated%20grey%20and%20amber%20tones%2C%20tense%20cold%20war%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=tvcover-10&orientation=portrait",
    year: 2024,
    region: "欧洲",
    genres: ["谍战", "悬疑", "动作"],
    rating: 8.3,
    director: "Klaus Berger",
    actors: ["Thomas Wolf", "Anna Berg", "Victor Lang"],
    summary: "冷战余温未散，一名身份成谜的特工被卷入跨越三个国家的情报博弈。在谎言与背叛之间，信任成了最奢侈的东西。",
    duration: 48,
    status: "全20集",
    episodes: [
      { id: "t10e1", number: 1, title: "柏林任务", duration: 48 },
      { id: "t10e2", number: 2, title: "双重身份", duration: 47 },
      { id: "t10e3", number: 3, title: "维也纳交接", duration: 49 },
    ],
    tags: ["谍战", "悬疑", "烧脑"],
  },
];